import { render, staticRenderFns } from "./AppointmentFormConfirmation.vue?vue&type=template&id=8991a71c&"
import script from "./AppointmentFormConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppointmentFormConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8991a71c')) {
      api.createRecord('8991a71c', component.options)
    } else {
      api.reload('8991a71c', component.options)
    }
    module.hot.accept("./AppointmentFormConfirmation.vue?vue&type=template&id=8991a71c&", function () {
      api.rerender('8991a71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentFormConfirmation.vue"
export default component.exports